import { useQuery } from '@tanstack/react-query'
import { useDI } from '@/di/DIContext'
import type { AgentId } from '@/domain/shared/Brand'

export function useHomeRevenueSummary() {
  const { performanceService, sessionService } = useDI()
  const agentId = sessionService.getAgentId()

  return useQuery({
    queryKey: ['homeRevenueSummary', agentId],
    queryFn: () => performanceService.getHomeRevenueSummary(agentId as AgentId),
    enabled: !!agentId,
    retry: false,
  })
}
